import m from "mithril";
import MessageProvider from "../../../MessageProvider"
import DateRangeComponent from "../../common/DateRangeComponent"
import SpinnerBoxComponent from '../../common/SpinnerBoxComponent';
import RoomSearchFormState from "../../../states/RoomSearchFormState";
import '../../common/ToolTip.css';
import { GuestType } from "../../../states/HotelSearchCriteria";

interface Attrs {
    messageProvider: MessageProvider;
    roomSearchFormState: RoomSearchFormState;    
    isOpeningDialog?: boolean,
    onSearchClick: () => void;
    onDateRangePickerClick: () => void;
    onRoomCountChange: (numberOfRoom: number) => void;
    onNationalityClick: (guestType: GuestType) => void;
}


let isSearched = false;
let showRequiredGuestTypeMessage = false;
let showRequiredDateRangeMessage = false;

const RoomSearchFormComponent: m.Component<Attrs> = {
    oninit(vnode) {
        isSearched = false
    },
    onbeforeupdate(vnode){
        showRequiredDateRangeMessage = !vnode.attrs.isOpeningDialog && isSearched && !vnode.attrs.roomSearchFormState.checkInDate;
        showRequiredGuestTypeMessage = !showRequiredDateRangeMessage && !vnode.attrs.isOpeningDialog && isSearched && !vnode.attrs.roomSearchFormState.guestType;
    },
    onupdate(vnode){
        isSearched = false;
    },
    view(vnode) {
        const { messageProvider, roomSearchFormState, onSearchClick, onDateRangePickerClick, onRoomCountChange, onNationalityClick } = vnode.attrs;
        
        return m("div.pt-3", { class: "bg-white" }, [
            m("form", { class: "non-selectable search-form-grid search-form-grid-desktop"}, [
                m("div", { id: "date-selection" },
                    m(DateRangeComponent, {
                        showHightLight: showRequiredDateRangeMessage,
                        checkin: roomSearchFormState.checkInDate,
                        checkout: roomSearchFormState.checkOutDate,
                        checkinPlaceholder: messageProvider.get("checkin_date"),
                        checkoutPlaceholder: messageProvider.get("checkout_date"),
                        singularNightLabel: messageProvider.get("night"),
                        pluralNightLabel: messageProvider.get("nights"),
                        onDateRangePickerClick: function () {
                            onDateRangePickerClick()
                            isSearched = false
                            showRequiredDateRangeMessage = false
                            showRequiredGuestTypeMessage = false
                        }
                    }),
                    showRequiredDateRangeMessage?
                    m("div.tooltip",
                        m("span.tooltiptext.mt-2", messageProvider.get("required_dates"))
                    ):null,
                ),

                m("div", {
                    id: "room-count-option"
                },
                    m(SpinnerBoxComponent, {
                        placeholder: messageProvider.get("number_of_room"),
                        singularLabel: messageProvider.get("room"),
                        pluralLabel: messageProvider.get("rooms"),
                        initialValue: roomSearchFormState.numberOfRooms,
                        minCount: 1,
                        maxCount: 4,
                        onCountChange: function (newValue) {
                            onRoomCountChange(newValue)
                        }
                    })
                ),
                m("div", {id: "traveller-type-option"},
                    m("div.d-flex align-items-center border rounded",
                        m("div.clickable flex-fill border-right py-2 pl-2", {
                            onclick: function () {
                                onNationalityClick("LOCAL");
                                isSearched = false
                            }
                        }, [
                            ((roomSearchFormState.guestType == "LOCAL") ?
                                m("i.bi bi-record-circle text-secondary"):
                                m("i.bi bi-circle text-secondary")
                            ), m("span.pl-2", messageProvider.get("local"))
                        ]),
                        m("div.clickable py-2 pl-2 flex-fill", {
                            onclick: function () {
                                onNationalityClick("FOREIGNER");
                                isSearched = false
                            }
                        }, [
                            ((roomSearchFormState.guestType == "FOREIGNER") ?
                                m("i.bi bi-record-circle text-secondary"):
                                m("i.bi bi-circle text-secondary")
                            ), m("span.pl-2", messageProvider.get("foreigner"))
                        ])
                    ),
                    showRequiredGuestTypeMessage?
                    m("div.tooltip",
                        m("span.tooltiptext mt-2", messageProvider.get("required_guest_type"))
                    ):null
                ),

                m("div", { id: "submit-button" }, [
                    m("div", (roomSearchFormState.isValid() && isSearched) ?
                        [
                            m("button", {
                                class: "text-white btn btn-block btn-primary shadow-sm mmd-ripple raised pt-2 pb-2 rounded",
                                disabled: isSearched
                            },  m("span", {
                                "role":"status",
                                class:"spinner-border spinner-border-sm mr-2"
                            }), messageProvider.get("search_room"))
                        ]:
                        m("button", {
                            class: "btn btn-block btn-primary shadow-sm mmd-ripple raised pt-2 pb-2 rounded",
                            onclick: function (event) {
                                event.preventDefault();
                                isSearched = true
                                if(roomSearchFormState.isValid()) {
                                    onSearchClick()
                                }
                            },
                            disabled: false
                        },  m("i.bi bi-search text-white-dark px-2"), messageProvider.get("search_room"))
                    )
                ])

            ])
        ])
    }
};

export default RoomSearchFormComponent;

